const variants = {
  primary:
    'bg-[#d61f74] text-white hover:bg-[#b91c66] focus:ring-[#d61f74] shadow-[0_12px_30px_-18px_rgba(214,31,116,0.55)]',
  secondary:
    'bg-secondary-600 text-white hover:bg-secondary-700 focus:ring-secondary-500',
  danger: 'bg-accent-600 text-white hover:bg-accent-700 focus:ring-accent-500',
  outline:
    'bg-white text-stone-700 border-stone-300 hover:bg-stone-50 focus:ring-primary-500',
};

const sizes = {
  sm: 'min-h-[40px] px-3 py-2 text-sm',
  md: 'min-h-[44px] px-4 py-2.5 text-sm',
  lg: 'min-h-[48px] px-5 py-3 text-base',
  xl: 'min-h-[52px] px-6 py-3 text-base',
};

const Button = ({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...props
}) => {
  return (
    <button
      className={`
        inline-flex items-center justify-center
        font-semibold rounded-2xl
        border border-transparent
        focus:outline-none focus:ring-2 focus:ring-offset-2
        transition-colors duration-200
        disabled:opacity-50 disabled:cursor-not-allowed
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
